import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController
} from "ionic-angular";
import { FormBuilder, Validators } from "@angular/forms";
import { ConectorProvider } from "../../providers/conector/conector";

@IonicPage()
@Component({
  selector: "page-nueva-comunicacion",
  templateUrl: "nueva-comunicacion.html"
})
export class NuevaComunicacionPage {
  formulario: any;
  data: any = {};
  loading: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private conector: ConectorProvider,
    public loadingController: LoadingController
  ) {
    this.formulario = formBuilder.group({
      descripcion: ["", Validators.required]
    });
    this.data = {
      background: "assets/images/background/39.jpg"
    };
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad NuevaComunicacionPage");
  }

  enviarMensaje() {
    this.presentLoading();
    this.conector
      .enviarMensaje(this.formulario.controls.descripcion.value)
      .subscribe(res => {
        this.conector.presentToast("Mensaje Enviado", 1500, "middle");
        this.loading.dismiss();
        this.formulario.controls.descripcion.value = "";
        this.navCtrl.pop();
      });
  }

  async presentLoading() {
    this.loading = this.loadingController.create({
      content: "Enviando...",
      duration: 3500
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/nueva-comunicacion/nueva-comunicacion.ts